import {Location, MeasurementsResult, Organisation} from '@flowmaps-com/flowmaps-typescriptmodels';

export interface LocationWithMeasurements {
    location: Location;
    organisationId: string;
    measurements: MeasurementsResult[];
}

export function mapMeasurementsToLocations(
    organisations: Organisation[], byEntity: MeasurementsResult[]
): LocationWithMeasurements[] {
    const measurementsByEntityId = new Map<string, MeasurementsResult[]>();
    for (const result of byEntity || []) {
        const results = measurementsByEntityId.get(result.entityId) || [];
        results.push(result);
        measurementsByEntityId.set(result.entityId, results);
    }

    return (organisations || []).flatMap(organisation => (organisation.locations || []).flatMap(location => {
        const entityIds = new Set([location.locationId, ...(location.aliasIds || [])]);
        const measurements = [...entityIds].flatMap(entityId => measurementsByEntityId.get(entityId) || []);
        return measurements.length > 0 ? [{location, organisationId: organisation.organisationId, measurements}] : [];
    }));
}
